import Swiper from 'swiper';
import { Pagination, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';

export const initProjectsCarousel = () => {
  const el = document.querySelector('.projects__slider');
  if (!el) return;

  new Swiper(el, {
    modules: [Pagination, EffectFade],
    effect: 'fade',
    fadeEffect: { crossFade: true },
    loop: true,
    speed: 900,
    pagination: {
      el: '.projects__pagination',
      clickable: true,
    },
  });
};
